import S3ImageUploader from "@common-components/s3-image-uploader";
import { SIGNED_URL_UPLOAD_TYPE, useAnalytics, useError, useLoader, useNotification, useUpdateSpace, } from "@piiqtechnologies/ui-lib";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
export const SpaceFloorplan = ({ floorplan, spaceId }) => {
    const intl = useIntl();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const analytics = useAnalytics();
    const { setNotification } = useNotification();
    const [updateSpace, spaceUpdated, isUpdatingSpace, updateSpaceError] = useUpdateSpace();
    useEffect(() => {
        setLoader(isUpdatingSpace);
        return () => setLoader(false);
    }, [isUpdatingSpace]);
    useEffect(() => {
        if (updateSpaceError) {
            setError(updateSpaceError === null || updateSpaceError === void 0 ? void 0 : updateSpaceError.message);
        }
    }, [updateSpaceError]);
    useEffect(() => {
        if (spaceUpdated) {
            setNotification(intl.formatMessage(messages.updateSpaceFloorplanSuccess));
            analytics.track("Floorplan Uploaded");
        }
    }, [spaceUpdated]);
    const onFloorplanChange = (imageUrl) => {
        const spaceAtts = {
            _id: spaceId,
            floorPlan: {
                name: (floorplan === null || floorplan === void 0 ? void 0 : floorplan.name) || "",
                url: imageUrl || "",
            },
        };
        updateSpace(spaceAtts);
    };
    return (React.createElement(S3ImageUploader, { imageKey: spaceId, imageUrl: floorplan === null || floorplan === void 0 ? void 0 : floorplan.url, label: intl.formatMessage(messages.spaceFloorplanUploadTitle), onChange: onFloorplanChange, bucket: SIGNED_URL_UPLOAD_TYPE.FLOORPLAN }));
};
export default SpaceFloorplan;
